import { z } from 'zod'

export const switchUserSchema = z
    .object({
        badgeNumber: z.string().optional(),
        noBadge: z.boolean().default(false),
        author: z.string().min(1, 'Check your name'),
    })
    .superRefine((data, ctx) => {
        if (data['badgeNumber']?.trim() === '' && data.noBadge !== true) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Check your badge number',
                path: ['badgeNumber'],
            })
        }
    })
